<template>
    <div>

     <v-container>
    <v-row no-gutters>
      <v-col :v-if="fimSchema"
        cols="12"
        sm="6"
        md="8"

      >
          <h1>{{fimSchema.serviceFeature.name}} <OZGLevelEmoji :level="fimSchema.serviceFeature.implementationLevel" /></h1>

          <p
          >
              {{fimSchema.serviceFeature.description}}
              <b>Quelle: <a :href="fimSchema.prototypeDocument.url" target="_blank">xDatenfelder-Schema im OZG-Portal</a></b>
          </p>
      <v-form v-model="valid">
        <v-jsf v-model="model" :schema="JSON.parse(fimSchema.jsonSchema)"/>
      </v-form>
        </v-col>
    </v-row>
     </v-container>
    </div>
</template>

<script>
import VJsf from '@koumoul/vjsf/lib/VJsf.js'
import '@koumoul/vjsf/lib/VJsf.css'
import '@koumoul/vjsf/lib/deps/third-party.js'
import OZGLevelEmoji from "./OZGLevelEmoji";

export default {
  name: 'FormRenderer',
    props: ["id"],
  components: {OZGLevelEmoji, VJsf },
  data: () => ({
    valid: false,
    model: {},
      fimSchema: false,
    schema: require("../assets/test_schema.json"),
  }),
    apollo: {
    $client: "ozgClient",
    fimSchema: {
      query: require("../graphql/fimSchemabyID.gql"),

        variables() {
        // Use vue reactive properties here
        return {
          id: this.$props.id
        };
      }
    },
  }
};
</script>
